import { Spacing } from '@persona-id/design-tokens';
import styled, { css } from 'styled-components';

import { BillingInfo } from 'dashboard/models/organization';
import IconPaymentAmex from 'images/icons/payment/amex.svg';
import IconPaymentDefault from 'images/icons/payment/default.svg';
import IconPaymentDiners from 'images/icons/payment/diners.svg';
import IconPaymentDiscover from 'images/icons/payment/discover.svg';
import IconPaymentJcb from 'images/icons/payment/jcb.svg';
import IconPaymentMastercard from 'images/icons/payment/mastercard.svg';
import IconPaymentUnionpay from 'images/icons/payment/unionpay.svg';
import IconPaymentVisa from 'images/icons/payment/visa.svg';

const Container = styled('div')`
  display: grid;
  grid-template-columns: 40px 250px 100px 1fr;
  grid-gap: ${Spacing[4]};

  svg {
    width: 100%;
    height: 100%;
  }
`;

const CardInfo = styled('div')``;

const Expiration = styled('div')<{ isExpired: boolean }>`
  ${({ theme, isExpired }) =>
    isExpired &&
    css`
      color: ${theme.color.variants.danger.default};
    `};
`;

interface CurrentCardInfoProps {
  billingInfo: BillingInfo;
}

export default ({ billingInfo }: CurrentCardInfoProps) => {
  const {
    'card-brand': brand,
    'card-last-4': last4,
    'card-exp-year': expYear,
    'card-exp-month': expMonth,
  } = billingInfo;

  // Credit cards expire at midnight on the last day of their expiration month.
  // The timezone for expiration appears to be slightly arbitrary depending on
  // the processing network, and not exactly knowable until the card is
  // charged.
  const today = new Date();
  const isExpired = today >= new Date(expYear, expMonth, 0);
  const expDate = expMonth < 10 ? `0${expMonth}/${expYear % 100}` : `${expMonth}/${expYear % 100}`;

  let cardIcon;
  switch (brand) {
    case 'American Express':
      cardIcon = <IconPaymentAmex />;
      break;
    case 'Diners Club':
      cardIcon = <IconPaymentDiners />;
      break;
    case 'Discover':
      cardIcon = <IconPaymentDiscover />;
      break;
    case 'JCB':
      cardIcon = <IconPaymentJcb />;
      break;
    case 'MasterCard':
      cardIcon = <IconPaymentMastercard />;
      break;
    case 'UnionPay':
      cardIcon = <IconPaymentUnionpay />;
      break;
    case 'Visa':
      cardIcon = <IconPaymentVisa />;
      break;
    default:
      cardIcon = <IconPaymentDefault />;
      break;
  }

  return (
    <Container data-test='current-card-information'>
      {cardIcon}
      <CardInfo data-test='current-card-information__card-number'>
        {brand} ending in <strong>{last4}</strong>
      </CardInfo>
      <Expiration data-test='current-card-information__expiration' isExpired={isExpired}>
        Expires {expDate}
      </Expiration>
    </Container>
  );
};
